module.exports = __webpack_public_path__ + "img/purchaseBtn.0bc7f4ce.png";